import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useOutletContext } from "react-router-dom";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { TripleGrid } from "../../commonComponents/Grids";
import { Button } from "../../commonComponents/Buttons";
import {
  RemoveChallengesModal,
  ChallengesViewModal,
  ConfirmationModal,
} from "../../modals";

import challengesService from "../../../services/challengesService";
import {
  get_kids_challenge,
  get_owner_challenge,
  get_more_kids_challenge,
} from "../../../redux/features/challengeSlice";

import {
  LikedIcon,
  UnlikedIcon,
  DefaultCover,
  VideoViewsIcon,
} from "../../../assets";

function KidsChallenges() {
  const { t } = useTranslation();
  const params = useParams();
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const kidsChallengesInfo = useSelector(
    (state) => state?.challenges?.kidsChallenges
  );
  const dispatch = useDispatch();
  const [count] = useOutletContext();
  const [kidsChallenges, setKidsChallenges] = useState();
  const [ownerChallenges, setOwnerChallenges] = useState();
  const [checkedItems, setCheckedItems] = useState([]);
  const [visibleRemoveChallengesModal, setVisibleRemoveChallengesModal] =
    useState(false);
  const [visibleViewChallengesModal, setVisibleViewChallengesModal] =
    useState(false);
  const [
    visibleRemoveSingleChallengesModal,
    setVisibleRemoveSingleChallengesModal,
  ] = useState(false);
  const [userAnswers, setUserAnswers] = useState([]);
  const [viewsCounter, setViewsCounter] = useState([]);
  const [expandUserId, setExpandUserId] = useState();

  useEffect(() => {
    if (!kidsChallenges) {
      let args = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
      };
      dispatch(get_kids_challenge(args)).then((result) => {
        setKidsChallenges(result?.payload?.results);
      });
    }
  }, [kidsChallenges, params.categoryId, params.challengeId, dispatch]);

  useEffect(() => {
    if (!ownerChallenges && userInfo?.id) {
      let args = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
        userId: userInfo.id,
      };
      dispatch(get_owner_challenge(args)).then((result) => {
        setOwnerChallenges(result?.payload);
      });
    }
  }, [ownerChallenges, dispatch, params, userInfo]);

  function likeHandler(kidChallengeId) {
    challengesService
      .addKidsChallengeLike(
        params.categoryId,
        params.challengeId,
        kidChallengeId
      )
      .then((result) => {
        let tempArray = [...kidsChallenges];
        const index = kidsChallenges.findIndex(
          (item) => item?.id === kidChallengeId
        );
        tempArray[index] = {
          ...tempArray[index],
          liked: result?.data?.result?.liked,
          likes: result?.data?.result?.likes,
        };
        setKidsChallenges(tempArray);

        if (userAnswers?.length) {
          let tempArray = [...userAnswers];
          const index = userAnswers.findIndex(
            (item) => item?.id === kidChallengeId
          );
          tempArray[index] = {
            ...tempArray[index],
            liked: result?.data?.result?.liked,
            likes: result?.data?.result?.likes,
          };
          setUserAnswers(tempArray);
        }
      });
  }

  function getChallengeBLock(item) {
  
    if (item?.answer_type === "text") {
      return (
        <>
          <Button
            onClick={() => expandChallenges(item?.user?.id)}
            customClassName={`challengeTextBlock ${
              item?.user?.request_user && "ownerBorder"
            } ${item?.status === "pending" && "pendingText"}`}
            viewType="clildrenBtn"
          >
            <p className="challengeText">{item?.title}</p>
          </Button>
        </>
      );
    } else if (
      item?.answer_type === "video" ||
      item?.answer_type === "image" ||
      item?.answer_type === "pdf"
    ) {
      return (
        <>
          <Button
            onClick={() => expandChallenges(item?.user?.id)}
            customClassName="challengeFileBlock"
            viewType="clildrenBtn"
          >
            <img
              className={`challengeImage ${
                item?.status === "pending" && "pendingImage"
              } ${item?.user?.request_user && "ownerBorder"}`}
              src={
                item?.answer_type === "video" && !item?.cover_image
                  ? DefaultCover
                  : item?.cover_image
              }
              alt={t("challenge")}
            />
          </Button>
        </>
      );
    }

    return null;
  }

  function dotCounter(answersCount) {
    if (answersCount === 2) {
      return (
        <>
          <li className="active"></li>
          <li></li>
        </>
      );
    } else if (answersCount > 2) {
      return (
        <>
          <li className="active"></li>
          <li></li>
          <li></li>
        </>
      );
    }
  }

  function expandChallenges(userId) {
    challengesService
      .getOwnerChallenges(params.categoryId, params.challengeId, userId)
      .then((response) => {
        setUserAnswers(response.data);
        setVisibleViewChallengesModal(true);
      });
  }

  function deleteChallenges() {
    if (checkedItems.length) {
      let args1 = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
      };
      let args2 = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
        userId: userInfo.id,
      };
      challengesService
        .deleteOwnerChallenges(
          params.categoryId,
          params.challengeId,
          userInfo.id,
          checkedItems
        )
        .then(() => {
          dispatch(get_kids_challenge(args1)).then((result) => {
            setKidsChallenges(result?.payload?.results);
          });
          dispatch(get_owner_challenge(args2)).then((result) => {
            setOwnerChallenges(result?.payload);
          });
        });
    }

    setVisibleRemoveChallengesModal(false);
  }

  function deleteSingleChallenge() {
    if (checkedItems) {
      let args = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
      };
      challengesService
        .deleteOwnerChallenges(
          params.categoryId,
          params.challengeId,
          userInfo.id,
          checkedItems
        )
        .then(() => {
          dispatch(get_kids_challenge(args)).then((result) => {
            setKidsChallenges(result?.payload?.results);
          });
          challengesService
            .getOwnerChallenges(
              params.categoryId,
              params.challengeId,
              userInfo.id
            )
            .then((response) => {
              setUserAnswers(response.data);
            });
          setVisibleRemoveSingleChallengesModal(false);
        });
    }
  }

  function loadMore() {
    dispatch(get_more_kids_challenge(kidsChallengesInfo.next)).then(
      (result) => {
        setKidsChallenges(kidsChallenges.concat(result?.payload?.results));
      }
    );
  }

  function closeViewModal() {
    setVisibleViewChallengesModal(false);
    if (count?.type !== "video") {
      let newData = {
        user_id: expandUserId,
        ids: [],
      };
      let viewdIds;
      if (viewsCounter.length) {
        viewdIds = viewsCounter.filter((element, index) => {
          return viewsCounter.indexOf(element) === index;
        });
      }
      newData.ids = viewdIds;
      challengesService
        .addChallengeAnswerView(params.categoryId, params.challengeId, newData)
        .then((response) => {
          if (response.status === 200) {
            setViewsCounter([]);
            setExpandUserId();
            let tempArray = [...kidsChallenges];
            const index = kidsChallenges.findIndex(
              (item) =>
                item?.id === response?.data?.last_viewed_challenge_answer?.pk
            );
            tempArray[index] = {
              ...tempArray[index],
              views: response?.data?.last_viewed_challenge_answer?.views,
            };
            setKidsChallenges(tempArray);
          }
        });
    }
    setViewsCounter([]);
    setExpandUserId();
  }

  return (
    <>
      <TripleGrid
        title={count?.title}
        legend={count?.description}
        viewType="middle"
        ifPagination={kidsChallengesInfo?.next ? true : false}
        paginationClick={loadMore}
      >
        <li>
          <NavLink
            to={`/challenge-upload/${count?.type}/${params.categoryId}/${params.challengeId}`}
            className={`addChallengeBtn ${
              count?.type === "text" && "smallCard"
            }`}
          >
            +{t("addChallenge")}
          </NavLink>
        </li>
        {kidsChallenges &&
          kidsChallenges?.map((item) => (
            <li key={item?.id}>
              <div
                className={`kidsChallengeCard ${
                  count?.type === "text" && "smallCard"
                }`}
              >
                {item?.status === "pending" && item?.user?.request_user && (
                  <div className="cardLabel pendingLabel">{t("pending")}</div>
                )}
                {item?.status === "approved" &&
                  item?.user?.request_user &&
                  item?.approved_recently && (
                    <div className="cardLabel approvedLabel">
                      {t("approved")}
                    </div>
                  )}

                {getChallengeBLock(item)}

                <Button
                  onClick={() => expandChallenges(item?.user?.id)}
                  customClassName="fullScreenBtn"
                  iconClassName="hasIcon--maximize"
                />
                <div className="dotsCounter">
                  <ul className="dotsCounterList">
                    {dotCounter(item?.answers_count)}
                  </ul>
                </div>
                <div className="infoBlock">
                  {count?.type !== "text" && (
                    <p className="challengeTitle">{item?.title}</p>
                  )}

                  <p className="ownerTitle">
                    {item?.user?.name}
                    {item?.user?.age
                      ? `, ${item?.user?.age} ${t("years")}`
                      : `, ? ${t("years")}`}
                    {item?.user?.request_user && ` (${t("you")})`}
                  </p>

                  <div className="activityCounter">
                    <div className="leftBlock">
                      <div className="viewsCounter">
                        <img
                          className="activityIcon"
                          src={VideoViewsIcon}
                          alt={t("views")}
                        />
                        <p className="activityTxt">{item?.views}</p>
                      </div>
                      <div>
                        <Button
                          viewType="clildrenBtn"
                          onClick={() => likeHandler(item?.id)}
                        >
                          <img
                            className="activityIcon"
                            src={item?.liked ? LikedIcon : UnlikedIcon}
                            alt={t("likes")}
                          />
                        </Button>
                        <p className="activityTxt">{item?.likes}</p>
                      </div>
                    </div>

                    {item?.user?.request_user && (
                      <Button
                        customClassName="trashBtn"
                        viewType="transparentIcon"
                        iconClassName="hasIcon--trash-2"
                        onClick={() => setVisibleRemoveChallengesModal(true)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </li>
          ))}
        {visibleRemoveChallengesModal && (
          <RemoveChallengesModal
            setVisibleRemoveChallengesModal={setVisibleRemoveChallengesModal}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            deleteChallenges={deleteChallenges}
            data={ownerChallenges}
            challengeType={count?.type}
          />
        )}

        {visibleViewChallengesModal && (
          <ChallengesViewModal
            setVisibleViewChallengesModal={setVisibleViewChallengesModal}
            setVisibleRemoveSingleChallengesModal={
              setVisibleRemoveSingleChallengesModal
            }
            setCheckedItems={setCheckedItems}
            closeViewModal={closeViewModal}
            setExpandUserId={setExpandUserId}
            expandUserId={expandUserId}
            type={count?.type}
            setViewsCounter={setViewsCounter}
            userAnswers={userAnswers}
            likeHandler={likeHandler}
            categoryId={params.categoryId}
            challengeId={params.challengeId}
          />
        )}

        {visibleRemoveSingleChallengesModal && (
          <ConfirmationModal
            setConfirmationModal={setVisibleRemoveSingleChallengesModal}
            deleteFunction={deleteSingleChallenge}
            modalTitle={t("removeConfirmation")}
            modalLegend={t("undoneProcess")}
            modalConfirmBtn={t("deleteChallenge")}
          />
        )}
      </TripleGrid>
    </>
  );
}

export default KidsChallenges;
